module.exports = __webpack_public_path__ + "static/media/banner_3.1bfa45cd.png";